import { Agency, agencyDetailed } from '@app/models/agency';
import { Corridor, corridor } from '@app/pcs/models/corridor';
import { DictionaryEntity } from '@app/pcs/models/dictionary-entity';
import { Label } from '@app/pcs/models/label';
import { OperationPoint, operationPoint } from '@app/pcs/models/operation-point';
import { PapRequestStatus } from '@app/pcs/models/pap-request-status';
import { ProcessType } from '@app/pcs/models/process-type';
import { ProgressStatus } from '@app/pcs/models/progress-status';
import { baseTimetablePeriod, TimetablePeriod } from '@app/pcs/models/timetable-period';
import { TrainType } from '@app/pcs/models/train-type';
import { gql } from 'apollo-angular';

export interface InvolvedAgencyTrafficLight {
  agency: Agency;
  progressStatus: ProgressStatus;
  imPermanentAcceptance: boolean;
}

export interface DossierSearchCriteria {
  dossierId?: number;
  internationalTrainNumber?: string;
  dossierName?: string;
  dossierRoute?: string;
  ttp?: TimetablePeriod;
  processType?: ProcessType;
  processTypes?: ProcessType[];
  dossierStatuses?: DictionaryEntity[];
  dossierType?: DictionaryEntity;
  phaseGroup?: DictionaryEntity;
  cataloguePathNumber?: string;
  trainNumber?: string;
  trainTypes?: TrainType[];
  labels?: Label[];
  operationPoints?: OperationPoint[];
  rfcCorridor?: Corridor;
  agencyInvolvement?: DictionaryEntity;
  appointedAsRu?: boolean;
  myProgressStatuses?: ProgressStatus[];
  imPermanentAcceptance?: boolean;
  involvedAgencies?: Agency[];
  progressStatuses?: ProgressStatus[];
  involvedAgencyTrafficLightPairs?: InvolvedAgencyTrafficLight[];
  transition?: any;
  papRequestStatuses?: PapRequestStatus[];
  showUnreadOnly?: boolean;
}

export const dossierSearchCriteria = gql`
  fragment dossierSearchCriteria on DossierSearchCriteria {
    dossierId
    internationalTrainNumber
    dossierName
    dossierRoute
    ttp {
      ...baseTimetablePeriod
    }
    processType {
      id
      description
    }
    processTypes {
      id
      description
    }
    dossierType {
      id
      description
    }
    dossierStatuses {
      id
      description
    }
    phaseGroup {
      id
      description
    }
    cataloguePathNumber
    trainNumber
    trainTypes {
      id
      description
    }
    labels {
      id
      name
      description
    }
    operationPoints {
      ...operationPoint
    }
    rfcCorridor {
      ...corridor
    }
    agencyInvolvement {
      id
      description
    }
    myProgressStatuses {
      id
      description
    }
    imPermanentAcceptance
    involvedAgencies {
      ...agencyDetailed
    }
    progressStatuses {
      id
      description
    }
    involvedAgencyTrafficLightPairs {
      agency {
        ...agencyDetailed
      }
      progressStatus {
        id
        description
      }
      imPermanentAcceptance
    }
    papRequestStatuses {
      status
    }
    showUnreadOnly
  }
  ${operationPoint}
  ${agencyDetailed}
  ${corridor}
  ${baseTimetablePeriod}
`;
